import classNames from 'classnames';
import { ButtonHTMLAttributes, FC, useState } from 'react';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';

import styles from './add.module.scss';

import { ReactComponent as IconCheck } from '../../../../assets/images/check-white.svg';
import { ReactComponent as IconClose } from '../../../../assets/images/close.svg';
import { collectionData, removeProductFromCollection, updateCollection, loadingProduct } from '../../../../store/collection';

interface IAddButton {
    horizontalMode?: boolean;
    removable: boolean;
    urn: string;
}

const AddButton: FC<IAddButton & ButtonHTMLAttributes<HTMLButtonElement>> = ({
    urn,
    className,
    horizontalMode = false,
    removable,
    ...props
}) => {
    const dispatch = useDispatch();
    const intl = useIntl();
    const collection = useSelector(collectionData);
    const [hover, setHover] = useState<boolean>(false);
    const isActive = collection.join('---').includes(urn);

    const loadingElement = () => {
        dispatch(isActive ? removeProductFromCollection(urn) : updateCollection(urn));
        if (!isActive) dispatch(loadingProduct(true));
    };
    const addButtonText = () => {
        if (isActive) {
            return (
                <span>
                    <IconCheck />
                    <span>{intl.formatMessage({ id: 'general.addedToList', defaultMessage: 'Zur Liste hinzugefügt' })}</span>
                </span>
            );
        }
        return (
            <span>
                + <span>{intl.formatMessage({ id: 'collection.nameOpenButton', defaultMessage: 'Merkliste' })}</span>
            </span>
        );
    };

    return (
        <button
            onClick={() => loadingElement()}
            className={classNames(
                styles.add,
                className,
                { [styles.active]: isActive },
                { [styles.horizontalMode]: horizontalMode }
            )}
            onMouseEnter={() => setHover(true)}
            onMouseLeave={() => setHover(false)}
            {...(removable && { removable: 'true' })}
            {...props}
            title={intl.formatMessage({
                id: 'general.addingProductsTooltip',
                defaultMessage: 'Produkt zur Auswahl hinzufügen',
            })}
        >
            {hover && isActive ? <IconClose width="10" height="10" stroke="#fff" stroke-width="4" /> : addButtonText()}
        </button>
    );
};

export default AddButton;
